import Modal from "bootstrap/js/dist/modal";

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        document.getElementById("modalImage").src = fullImg;
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items
        const hiddenItems = document.querySelectorAll(".gallery-item.d-none");
        if (!hiddenItems) {
            return;
        }
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem, index) => {
            //get the image from the item
            const img = hiddenItem.querySelector("img");
            if (!img) {
                return;
            }
            //get the data-src attribute
            const dataSrc = img.getAttribute("data-src");
            if (!dataSrc) {
                return;
            }
            //set the src attribute
            img.src = dataSrc;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
        });
        item.remove();
    });
});

// FAQ accordion
document.querySelectorAll(".accordion .accordion-button").forEach((button) => {
    button.addEventListener("click", () => {
        const accordion = button.closest(".accordion");
        if (!accordion) {
            return;
        }

        accordion.classList.toggle("active");
    });
});

// Service areas accordion
var acc = document.querySelectorAll(".service-area-inner button.accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
    });
}

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //stop propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});

//when the mobile menu is shown, check the position
let navbarToggler = document.querySelector(".navbar-toggler");
if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
        //get the .header-inner element
        let headerInner = document.querySelector(
            "#wrapper-navbar .header-inner",
        );
        if (!headerInner) {
            return;
        }

        //get the vertical position of the button relative to the window
        let pozY = navbarToggler.getBoundingClientRect().top;

        if (!pozY) {
            return;
        }

        if (pozY < 30) {
            //add class .scrolling to the .header-inner element
            headerInner.classList.add("scrolling");
        } else {
            //remove class .scrolling from the .header-inner element
            headerInner.classList.remove("scrolling");
        }
    });
}
